import styled from "styled-components"
import PropTypes from "prop-types"

const Input = styled.input.attrs({ type: "tel" })`
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  box-sizing: border-box;
  border: 1px solid
    ${(props) => {
      if (props.error) return props.theme.colors.error
      if (props.altBorderColor) return props.altBorderColor
      return props.backgroundColor
    }};
  border-radius: 4px;
  outline: none;
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  font-family: ${(props) =>
    props.avenirNextRegular
      ? props.theme.fonts.avenirNextRegular
      : props.theme.fonts.avenirNextDemi};
  font-size: 1rem;
  text-indent: ${(props) => props.textIndent};
  color: ${(props) => props.theme.colors.text.input};
  background-color: ${(props) => props.backgroundColor};
  &::placeholder {
    /* Most modern browsers support this now. */
    color: ${(props) => props.theme.colors.text.inputPlaceholder};
  }
  caret-color: ${(props) => props.theme.colors.primary};
  transition: all 500ms ease;
  box-shadow: ${(props) =>
    props.boxShadow ? "0px 8px 15px 0px rgba(35, 41, 48, 0.15)" : ""};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : null)};
  margin-bottom: ${(props) => props.marginBottom};

  @media (max-width: 768px) {
    height: 56px;
    font-size: 0.9rem;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    height: 48px;
    font-size: 0.85rem;
    text-indent: 16px;
  }
`

Input.defaultProps = {
  height: "70px",
  width: "100%",
  backgroundColor: "#FFF",
  textIndent: "15px",
}

Input.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  backgroundColor: PropTypes.string,
  textIndent: PropTypes.string,
}

export default Input
